import { borderColor, borderRadius, borderStyle, borderWidth } from '../../Utilities/utils/Theming';
import { StyleObject } from 'styletron-standard';

export const modalContainer = () => {
	return {
		backgroundColor: 'transparent',
		width: 'var(--epods--dossier-input-width)',
		position: 'relative',
	} as StyleObject;
};

export const dropdownStyle = () => {
	return {
		maxHeight: `var(--epods--dossier-input-modal-body-height)`,
		paddingRight: '30px !important',
	} as StyleObject;
};

export const blueContainer = () => {
	return {
		backgroundColor: 'var(--epods--color-bg-info)',
		color: 'var(--epods--color-text-primary)',
		display: 'flex',
		flexDirection: 'column',
		padding: '16px',
		marginTop: 'var(--epods--space-inset-m)',
	} as StyleObject;
};

export const subtitleContainer = () => {
	return {
		display: 'flex',
		alignItems: 'flex-start',
	} as StyleObject;
};

export const boldText = () => {
	return {
		color: 'var(--epods--color-text-primary)',
		fontFamily: 'var(--epods--font-secondary-bold)',
		marginLeft: 'var(--epods--space-inset-m)',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'break-spaces',
		textAlign: 'left',
	} as StyleObject;
};

export const modalHeaderText = () => {
	return {
		color: 'var(--epods--color-text-primary)',
		textAlign: 'left',
		marginTop: 'var(--epods--space-inset-s)',
	} as StyleObject;
};

export const externalLinkCenter = () => {
	return {
		alignSelf: 'center',
		marginTop: '16px',
	} as StyleObject;
};

export const externalLinkLeft = () => {
	return {
		alignSelf: 'flex-start',
		marginTop: '16px',
	} as StyleObject;
};

export const firstUsageExamples = () => {
	return {
		marginTop: 'var(--epods--space-inset-s)',
		marginLeft: 'var(--epods--space-inset-m)',
		paddingLeft: '48px',
		textAlign: 'left',
	} as StyleObject;
};

export const pointerCursor = (props: any) => {
	const { disabled, readOnly, error, customButton } = props;
	return { 
		cursor: disabled || readOnly ? 'not-allowed' : 'pointer',
		paddingRight: (customButton && !readOnly && !error) ? 'var(--epods--dossier-input-padding-right-width-custom-button)' : '12px',
	} as StyleObject;
};

export const popoverStyle = () => {
	return {
		marginTop: 'var(--epods--space-inset-s)',
		boxShadow: 'var(--epods--box-shadow-third-bottom)',
		...borderRadius('var(--epods--border-radius)'),
		...borderStyle("solid"),
		...borderWidth("var(--epods--border-width)"),
		...borderColor("var(--epods--color-border-light)"),
		backgroundColor: 'transparent',
		paddingBottom: '2px',
	} as StyleObject;
};

export const customButtonStyle = () => {
	return {
		position: 'absolute',
		right: '1px',
		top: '1px',
		zIndex: '1111',
		borderWidth: '0px 0px 0px 1px',
		borderTopLeftRadius: '0px',
		borderBottomLeftRadius: '0px',
		height: '28px',
		':focus': {
			zIndex: '1111',
		},
	} as StyleObject;
};
